import { action } from 'satcheljs';
import { PublicFolderStore } from '../store/publicFolderFavoriteStore';
import { BaseFolderType } from 'owa-folders';

export default action(
    'ADD_PUBLIC_FOLDER_TO_STORE',
    (state: PublicFolderStore, item: BaseFolderType) => {
        return {
            state,
            item,
        };
    }
);
